import { render, staticRenderFns } from "./serveFive.vue?vue&type=template&id=ebbc1f80&scoped=true&"
import script from "./serveFive.vue?vue&type=script&lang=js&"
export * from "./serveFive.vue?vue&type=script&lang=js&"
import style0 from "./serveFive.vue?vue&type=style&index=0&id=ebbc1f80&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebbc1f80",
  null
  
)

export default component.exports